<template>
  <div id="modal-wrapper">
    <modal-component ref="modal" @onModalClose="$emit('onModalClose')">
      <div id="print-check-modal" class="modal-container">
        <div class="modal-header">Print check</div>

        <div class="container">
          <div class="loading" v-if="isCheckLoading">
            <icon-component iconName="loader"/>
          </div>

          <pre
            v-else
            class="check-pre"
            v-text="check"
          ></pre>
        </div>

        <div class="modal-controls x2">
          <base-button text="CANCEL" classes="def-btn cancel-action-btn uppercase medium border-2" @onClick="close"/>
          <base-button text="PRINT" classes="def-btn main-action-btn uppercase medium border-2" @onClick="printCheck"/>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import BaseButton from "@/components/_shared/Button.vue";
import { printersService } from '@/_api/printers.api';
import iconComponent from "@/components/_shared/Icon.vue";

export default {
  name: 'PrintCheckModal',

  components: {
    ModalComponent,
    BaseButton,
    iconComponent,
  },

  emits: ['printMethods', 'onModalClose'],

  props: {
    selectedOrder: {
      type: Object,
      require: true
    }
  },

  data() {
    return {
      check: null,

      isCheckLoading: true,
    }
  },

  async mounted() {
    this.emmiter.on('closeModal', () => {
      if (this.$refs['modal']) {
        this.close();
      }
    });

    const orderId = this.selectedOrder.id;
    try {
      this.check = await printersService.getWebPrintInvoiceFile(orderId, 'plain-text');
    } catch (error) {
    } finally {
      this.isCheckLoading = false;
    }
  },

  beforeUnmount() {
    this.emmiter.off('closeModal');
    this.emmiter.emit('toggleModals', { opened: false, type: 'PrintCheckModal' });
  },

  methods: {
    openModal() {
      this.$refs['modal'].show();
      this.emmiter.emit('toggleModals', { opened: true, type: 'PrintCheckModal' });
    },
    close() {
      this.$refs['modal'].close();
      this.emmiter.emit('toggleModals', { opened: false, type: 'PrintCheckModal' });
    },
    printCheck() {
      this.$emit('printMethods', {
        type: 'invoice'
      })
    },
  }
}
</script>

<style scoped lang="less">
#modal-wrapper {
  #print-check-modal {
    width: 500px;

    .container {
      max-height: 450px;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .check-pre {
      all: revert;
      text-align: justify;
    }
  }
}
</style>
